import React, { useState } from 'react'
// import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Modal from '@material-ui/core/Modal'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

const CloseAccount = ({ closeAccount }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Typography variant="subtitle1" gutterBottom>
        Account
      </Typography>
      <Box>
        <Typography style={{ display:'inline-block', paddingRight: 16 }}>Close account:</Typography>
        <Button variant="contained" color="default" onClick={ () => setOpen(true) }>Close</Button>
      </Box>
      <Modal open={ open } onClose={() => setOpen(false)}>
        <Box style={{ width: '100dvw', height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Card>
            <CardContent>
              <Typography variant="h6">Do you want to close your account? Your mindfiles will be deleted. This cannot be undone.</Typography>
              <Box mt={ 3 } >
                <Button variant="contained" color="default" onClick={ closeAccount }>Close</Button>
                <Button variant="contained" color="secondary" onClick={ () => setOpen(false) } style={{ marginLeft: 16 }}>Cancel</Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </>
  )
}

export default CloseAccount
